import * as Yup from "yup";
import { getAppType } from "utils/helper";

const numberRegex = /^\d+$/;

const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/;

const noEmojiRegex = /\p{Extended_Pictographic}/u;

const sicRegex = /^[0-9]*$/;

export const addressDropdownValidationSchema = Yup.object().shape({
  officeLocationId: Yup.string().required("You missed this one"),
});

export const currentCoverageValidationSchema = Yup.object().shape({
  currentlyOfferHealthInsurance: Yup.string()
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  currentCarrier: Yup.string().when("currentlyOfferHealthInsurance", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .test(
        "no emoji",
        "Sorry, no emoji 😔",
        (value) => !noEmojiRegex.test(value || "")
      ),
  }),
  currentCarrierOther: Yup.string().when("currentCarrier", {
    is: "OTHER",
    then: Yup.string()
      .required("You missed this one")
      .test(
        "no emoji",
        "Sorry, no emoji 😔",
        (value) => !noEmojiRegex.test(value || "")
      ),
  }),
  currentRenewalDate: Yup.string()
    .matches(
      dateRegex,
      "Please enter your renewal date in the MM/DD/YYYY format"
    )
    .when("currentlyOfferHealthInsurance", {
      is: "Yes",
      then: Yup.string()
        .required("You missed this one")
        .test(
          "renewal date",
          "Great scott! Please pick a date in the future.",
          (value) => new Date(value || "") >= new Date()
        ),
    }),
  cobraUsage: Yup.string().when("currentlyOfferHealthInsurance", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .test(
        "no emoji",
        "Sorry, no emoji 😔",
        (value) => !noEmojiRegex.test(value || "")
      ),
  }),
  cobraUsers: Yup.string().when("cobraUsage", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .matches(numberRegex, "Numbers only, please.")
      .test(
        "no zero",
        "Please enter a value greater than 0",
        (value) => Number(value) > 0
      ),
  }),
  benefitEligibleEmployees: Yup.string().when("cobraUsage", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .matches(numberRegex, "Numbers only, please.")
      .test(
        "no zero",
        "Please enter a value greater than 0",
        (value) => Number(value) > 0
      ),
  }),
});

export const currentCoverageValidationSchemaCoreApp = Yup.object().shape({
  sicCode: Yup.string()
    .max(4, "SIC code is only 4 characters")
    .matches(sicRegex, "Numbers only, please.")
    .min(4, "SIC code is only 4 characters")
    .required("You missed this one"),
  currentlyOfferHealthInsurance: Yup.string()
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  currentCarrier: Yup.string().when("currentlyOfferHealthInsurance", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .test(
        "no emoji",
        "Sorry, no emoji 😔",
        (value) => !noEmojiRegex.test(value || "")
      ),
  }),
  currentCarrierOther: Yup.string().when("currentCarrier", {
    is: "OTHER",
    then: Yup.string()
      .required("You missed this one")
      .test(
        "no emoji",
        "Sorry, no emoji 😔",
        (value) => !noEmojiRegex.test(value || "")
      ),
  }),
  currentRenewalDate: Yup.string()
    .matches(
      dateRegex,
      "Please enter your renewal date in the MM/DD/YYYY format"
    )
    .when("currentlyOfferHealthInsurance", {
      is: "Yes",
      then: Yup.string()
        .required("You missed this one")
        .test(
          "renewal date",
          "Great scott! Please pick a date in the future.",
          (value) => new Date(value || "") >= new Date()
        ),
    }),
  cobraUsage: Yup.string().when("currentlyOfferHealthInsurance", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .test(
        "no emoji",
        "Sorry, no emoji 😔",
        (value) => !noEmojiRegex.test(value || "")
      ),
  }),
  cobraUsers: Yup.string().when("cobraUsage", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .matches(numberRegex, "Numbers only, please.")
      .test(
        "no zero",
        "Please enter a value greater than 0",
        (value) => Number(value) > 0
      ),
  }),
  benefitEligibleEmployees: Yup.string().when("cobraUsage", {
    is: "Yes",
    then: Yup.string()
      .required("You missed this one")
      .matches(numberRegex, "Numbers only, please.")
      .test(
        "no zero",
        "Please enter a value greater than 0",
        (value) => Number(value) > 0
      ),
  }),
  controlledGroup: Yup.string().required("You missed this one"),
  isOnPeo: Yup.string().when("currentlyOfferHealthInsurance", {
    is: (currentlyOfferHealthInsurance: string) =>
      currentlyOfferHealthInsurance === "Yes" &&
      getAppType() !== "HEALTH_INSURANCE_UPSELL",
    then: Yup.string().required("You missed this one"),
  }),
  currentPeo: Yup.string().when("isOnPeo", {
    is: "Yes",
    then: Yup.string().required("You missed this one"),
  }),
  currentPeoOther: Yup.string().when("currentPeo", {
    is: "Other",
    then: Yup.string().required("You missed this one"),
  }),
  startingCoverageDate: Yup.string()
    .matches(
      dateRegex,
      "Please enter your coverage date in the MM/DD/YYYY format"
    )
    .required("You missed this one")
    .test(
      "coverage year",
      "Great scott! Please pick a date in the future.",
      (value) => new Date(value || "") >= new Date()
    ),
});
